import {SyntheticEvent, useCallback} from 'react';
import {twMerge} from '../../../../common/twMerge';
import {BannerType} from '../../../../graphql/generated/types';
import {Icon} from '../../../atoms/Icon/Icon';
import {IconType} from '../../../atoms/Icon/IconType.enum';
import {BannerItemButtonProps} from './BannerItemButtonProps.interface';

export function BannerItemButton({
  isParentCarouselHasIndicator,
  bannerUid,
  bannerType,
  isPlaying,
  isMuted,
  onVideoMutedChange,
  onClickPlayVideo,
}: BannerItemButtonProps) {
  const onClickSound = useCallback(
    (e: SyntheticEvent) => {
      e.stopPropagation();
      e.preventDefault();
      onVideoMutedChange?.(!isMuted);
    },
    [isMuted, onVideoMutedChange]
  );

  const onClickPlay = useCallback(
    (e: SyntheticEvent) => {
      e.stopPropagation();
      e.preventDefault();
      onClickPlayVideo?.();
    },
    [onClickPlayVideo]
  );

  if (bannerType === BannerType.Video) {
    return (
      <div
        className={twMerge(
          'absolute bottom-15pxr right-15pxr flex',
          isParentCarouselHasIndicator && 'bottom-46pxr'
        )}
      >
        {bannerType === BannerType.Video && (
          <div className="flex items-center justify-center rounded-full cursor-pointer h-28pxr w-28pxr bg-static-mono-90">
            {isPlaying && (
              <Icon
                type={
                  isMuted
                    ? IconType.PlayerMuteStatic
                    : IconType.PlayerSoundStatic
                }
                onClick={onClickSound}
              />
            )}
            {!isPlaying && (
              <Icon type={IconType.PlayerPlayStatic} onClick={onClickPlay} />
            )}
          </div>
        )}
      </div>
    );
  }

  return null;
}
